import { Pagination } from "@/common/components/pagination";
import { H3 } from "@/common/elements";
import { BsEye } from "react-icons/bs";

interface ICartonDetails {
  data: string[];
  handler?: (item: string) => void;
}

const CartonDetails = ({ data, handler }: ICartonDetails) => {
  return (
    <div className="cartonWrapper">
      <H3>Carton Serials</H3>
      {data?.length > 0 ? (
        <>
          <div className="cartonWrapper">
            {data?.map((cat, index) => (
              <div className="cartonContainer">
                <div className="cartonList">
                  <h5 key={index}>{cat}</h5>
                  {handler && <BsEye size={20} onClick={() => handler(cat)} />}
                </div>
                <div className="separate"></div>
              </div>
            ))}
          </div>
          <div className="paginationWrapper">
            <div className="paginationController">
              <Pagination
                onNextPage={() => console.log("next requested")} //just for testing, to be removed
                onPerPageChange={() => console.log("per page change")} //just for testing, to be removed
                pageCount={2}
                dontShowLabel={true}
              />
            </div>
          </div>
        </>
      ) : (
        <h5>No Caton details provided</h5>
      )}
    </div>
  );
};

export default CartonDetails;
